import { defineStore, storeToRefs } from 'pinia'
import { useIGUserStore } from '~/modules/nuxt3-module-ingang/stores/user'
import appConfig from '~~/app.config.value'

const { appId } = appConfig

export const useUserStore = defineStore(`${appId}-user`, () => {
  const parent = useIGUserStore()
  const refs = storeToRefs(parent)
  return {
    ...refs,
    init: parent.init,
    ready: parent.ready,
    injectUser: parent.injectUser,
    requestLogout: parent.requestLogout,
    availPartnerAllowedFunction: parent.availPartnerAllowedFunction
  }
})